import React, { useContext, useState, useEffect } from "react";
import ButtonSubmit from "../ButtonSubmit";
import {
  CONST_GENDER_FEMALE,
  CONST_GENDER_MALE,
  isValidGender,
  simplyClick,
} from "../../helpers";

import "./GenderForm.scss";
import { ContextProfileUser } from "../../lib/profileContext";

function GenderForm({ nextStep }) {
  const [errorGender, setErrorGender] = useState(null);
  const genderLabel = {
    [CONST_GENDER_MALE]: "Man, looking for a woman",
    [CONST_GENDER_FEMALE]: "Woman, looking for a man",
  };
  const { data, setData } = useContext(ContextProfileUser);
  const [genderWasChanged, setGenderWasChanged] = useState(false);

const handlerSubmit = (e) => {
  e.preventDefault();

  if (!isValidGender(data.gender)) {
    setErrorGender("Please, choose your gender");
  } else {
    if (!genderWasChanged) {
      simplyClick("cl_lnd_lt2_i_am_choose", { text: genderLabel[data.gender] });
    }

    simplyClick("cl_lnd_lt2_i_am_next");
    nextStep();
  }
};

const handleAddTypeGender = (e) => {
  const value = e.target.value;
  setData({ ...data, gender: value });
  setGenderWasChanged(true);
  if (errorGender) setErrorGender(null);

  simplyClick("cl_lnd_lt2_i_am_choose", { text: genderLabel[value] });
};
  useEffect(() => {
    if (!data.gender) {
      setData({ ...data, gender: CONST_GENDER_MALE });
    }
  }, []);

  const options = Object.keys(genderLabel).map((key, index) => (
    <option value={key} key={`${key}_${index}`}>
      {genderLabel[key]}
    </option>
  ));

  return (
    <div className="promo__wrapper-gender">
      <form className="gender__form" onSubmit={handlerSubmit}>
        <div className="user__form-top">
          <h3>I am a</h3>
        </div>
        <div className="gender__form-content">
          <div className="custom-select gender">
            <div className="custom-select-me">
              <select
                onChange={handleAddTypeGender}
                className="gender"
                value={data.gender || ""}
              >
                {options}
              </select>
            </div>
          </div>
          {errorGender && <p className="error">{errorGender}</p>}
          <ButtonSubmit
            className={"button__global button__gender"}
            text={"NEXT"}
          />
          <div className="progress__dots">
            <span className="active"></span>
            <span className="active"></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </form>
    </div>
  );
}

export default GenderForm;